import { IMerchantAccount } from '../../../../interfaces/IMerchantAccount';
import UserManagementContent from './UserManagementContent';
import UserManagementHeader from './UserManagementHeader';

export interface IUserManagementView {
    users: IMerchantAccount[];
    isLoading: boolean;
}

const UserManagementView = ({
    users,
    isLoading
}: IUserManagementView) => {
    return (
        <div>
            <UserManagementHeader disabled={isLoading} />
            <UserManagementContent
                users={users}
                isLoading={isLoading}
            />
        </div>
    )
}

export default UserManagementView;